import { Pagination } from "react-admin";

const PaginationOptions = (props) => (
  <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />
);

export default PaginationOptions;
